import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { EVEntry, Palette } from '@uswitch/ev-core/react';
import { Badge, Type } from '@uswitch/spark';
import { TruCheckCircle } from '@uswitch/spark-icons/tru';
import { Modal, ModalClose } from '@uswitch/spark.modal';
import { useState } from 'react';
import { useDataSelector, useEntity } from '@uswitch/ev-utils/context/selectors';
import SocialSharing from '../social-sharing';
import WrappedTrustyleAuthor from '../author/trustyle-author';
import { getVariantPath } from '@uswitch/ev-utils/get-variant-path';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Fragment as _Fragment } from "theme-ui/jsx-runtime";
export var articleIntroStylePath = function articleIntroStylePath(field, variant) {
  return getVariantPath({
    atomicType: 'compounds',
    componentId: 'article-intro',
    variantName: variant,
    field: field
  });
};

var ArticleIntro = function ArticleIntro(_ref) {
  var description = _ref.description,
      _ref$socialSharing = _ref.socialSharing,
      socialSharing = _ref$socialSharing === void 0 ? true : _ref$socialSharing,
      title = _ref.title;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var rootEntityFields = useDataSelector(['rootEntity', 'fields']);
  var authors = rootEntityFields.authors,
      editors = rootEntityFields.editors,
      verifiers = rootEntityFields.verifiers,
      _rootEntityFields$fac = rootEntityFields.factChecked,
      factChecked = _rootEntityFields$fac === void 0 ? false : _rootEntityFields$fac,
      publishDate = rootEntityFields.publishDate,
      updatedDate = rootEntityFields.updatedDate;
  var authorEntity = useEntity(authors === null || authors === void 0 ? void 0 : authors[0]);
  var editorEntity = useEntity(editors === null || editors === void 0 ? void 0 : editors[0]);
  var verifierEntity = useEntity(verifiers === null || verifiers === void 0 ? void 0 : verifiers[0]);
  return _jsxs(_Fragment, {
    children: [_jsx(Palette, {
      as: Type.H1,
      sx: {
        variant: articleIntroStylePath('heading'),
        mt: 0,
        gridColumnStart: 1,
        gridColumnEnd: 2
      },
      px: {
        color: function color(palette) {
          return palette.headingColor || palette.textColor;
        }
      },
      children: title
    }), _jsxs("div", {
      sx: {
        gridColumnStart: 1,
        gridColumnEnd: 2
      },
      children: [_jsx(WrappedTrustyleAuthor, {
        author: authorEntity,
        editor: editorEntity,
        verifier: verifierEntity,
        publishDate: updatedDate || publishDate,
        showWrittenBy: true
      }), factChecked ? [_jsx(Badge, {
        variant: "success",
        leftIcon: _jsx(TruCheckCircle, {}),
        onClick: function onClick() {
          return setShowModal(true);
        },
        sx: {
          mb: 'lg',
          mt: 'xs'
        },
        children: "Fact Checked"
      }, "0"), showModal ? _jsx(Modal, {
        closeButton: _jsx(ModalClose, {
          onClick: function onClick() {
            return setShowModal(false);
          }
        }),
        children: _jsx(EVEntry, _objectSpread(_objectSpread({}, factChecked), {}, {
          forceHydrate: true
        }))
      }, "1") : null] : null, _jsx(Palette, {
        as: Type.Body1,
        sx: {
          variant: articleIntroStylePath('description')
        },
        px: {
          color: 'textColor'
        },
        children: description
      })]
    }), socialSharing ? _jsx("div", {
      sx: {
        variant: articleIntroStylePath('social-divider')
      },
      children: _jsx(SocialSharing, {
        wrap: false
      })
    }) : null]
  });
};

export default ArticleIntro;
//# sourceMappingURL=index.js.map